import { Stack, Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

export const DetailEmptyState: FC = () => {
	const { t } = useResource();
	const theme = useTheme();

	return (
		<Stack textAlign="center" gap={theme.spacingTokens.xs} pt={4}>
			<Typography variant="h3">
				{t(Resources.PortfolioDetail.SharedLabels.empty)}
			</Typography>
			<Typography variant="body2">
				{t(Resources.PortfolioDetail.SharedLabels.emptySubtitle)}
			</Typography>
		</Stack>
	);
};
